import { UserInfo } from "../domain/model/user-info";

export class StoreUpdateInfo {

  constructor(
    readonly lastServerUpdate: Date | null,
    readonly lastLocalUpdate: Date | null,
    readonly lastEditedByUser: UserInfo | null) {
  }
}
